// @flow

import React from 'react';
import styled, { css } from 'styled-components';

import { useImages } from 'hooks';
import { flex, flexInlineFlex, topMargin, Width, widths } from 'styles';
import type { AllImages } from 'hooks/use-images';
import { ImageLoader } from 'components/Gui';

const Wrapper = styled.section`
  ${flex()};
  ${({ marginTop }) => topMargin(...marginTop)};
  opacity: ${({ opacity }) => opacity};
  ${({ wrapperFlex }) => wrapperFlex && flexInlineFlex(...wrapperFlex)};

  > div {
    ${flex('space-evenly', 'center')};
    flex-wrap: wrap;

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      justify-content: space-between;
    }

    ${({ wrapperWidths }) =>
      css`
        ${widths(...wrapperWidths)}
      `};

    > div {
      ${flex()};
      padding: 12px 0;
      ${({ containerWidths }) =>
        css`
          ${widths(...containerWidths)}
        `};
    }
  }
`;

const Image = styled.div`
  width: ${({ width }) => `${width}px`};
`;

type Props = {
  marginTop?: number[],
  wrapperFlex?: boolean[],
  wrapperWidths: number[],
  containerWidths: number[],
  opacity?: number,
  imageList: {
    name: string,
    alt: string,
    width: number,
  }[],
  images: AllImages,
};

const EvenlySpacedImageList = ({
  marginTop = [48, 28, 44],
  opacity = 1,
  wrapperFlex,
  wrapperWidths,
  containerWidths,
  imageList,
  images,
  ...rest
}: Props) => {
  const getImage = useImages(images);
  return (
    <Wrapper
      {...rest}
      opacity={opacity}
      wrapperFlex={wrapperFlex}
      marginTop={marginTop}
      wrapperWidths={wrapperWidths}
      containerWidths={containerWidths}
      role="list">
      <div>
        {imageList.map(({ name, alt, width }, index) => (
          <div key={`EvenlySpacedImageList-${index}`} role="listitem">
            <Image width={width}>
              <ImageLoader image={getImage(name)} alt={alt} />
            </Image>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

EvenlySpacedImageList.contentType = 'EvenlySpacedImageList';

export default EvenlySpacedImageList;
